import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';
import {
  GetOfflineFilesListQueryParamsType,
  GetOfflineFilesListQueryResponseType,
} from '@/modules/OfflineFiles/queries/getOfflineFilesList/getOfflineFilesListQuery.type';

export const getOfflineFilesListFunction = (
  params: GetOfflineFilesListQueryParamsType,
): Promise<PaginationResponseType<GetOfflineFilesListQueryResponseType>> => {
  return fetchApi.get('offline_shooting/list/', { params });
};
